/*
 * EzyRefurb — COD festival notice banner
 * Shows a notice inside the COD payment popup when the customer picks a
 * Cash-on-Delivery option, steering them towards Online Payment.
 *
 * Purely additive: it only reads the popup's own "cod-selected" class and
 * inserts its own element. It never touches the COD app's logic, amounts,
 * cart attributes or checkout flow. Remove this file + its <script> tag in
 * layout/theme.liquid to fully revert.
 *
 * Added: 2026-08-05 (Kanwar Yatra COD pickup restriction)
 */
(function () {
  'use strict';

  if (window.__ezyCodNoticeLoaded) return;
  window.__ezyCodNoticeLoaded = true;

  /* ---- The message (edit these two lines to change the wording) ---- */
  var HEADING = 'Kanwar Yatra — COD orders are delayed';
  var MESSAGE =
    'Our Cash-on-Delivery courier partner has restricted pickups during the Kanwar Yatra, ' +
    'so COD orders will be dispatched after approximately 1 week. ' +
    'Choose Online Payment for faster processing — those orders ship through our express partner.';

  /* Option rows in the COD popup that count as "COD" */
  var COD_OPTION_IDS = ['codOptionPartial', 'codOptionFullCod'];
  var SELECTED_CLASS = 'cod-selected';

  var CSS =
    '.ezy-cod-notice{display:none;margin:-2px 0 12px;padding:10px 12px;' +
    'border:1px solid #F0C070;border-radius:10px;background:#FFF6E8;color:#7A4A00;' +
    'font-size:13px;line-height:1.45;text-align:left;gap:8px;align-items:flex-start}' +
    '.ezy-cod-notice.ezy-is-visible{display:flex}' +
    '.ezy-cod-notice__icon{flex:0 0 auto;font-size:14px;line-height:1.5}' +
    '.ezy-cod-notice__text{flex:1 1 auto}' +
    '.ezy-cod-notice__text strong{display:block;margin-bottom:2px;font-weight:600;color:#8A4B00}' +
    '@media (max-width:480px){.ezy-cod-notice{font-size:12px;padding:9px 10px;margin-bottom:10px}}';

  function injectStyles() {
    if (document.getElementById('ezy-cod-notice-css')) return;
    var style = document.createElement('style');
    style.id = 'ezy-cod-notice-css';
    style.textContent = CSS;
    (document.head || document.documentElement).appendChild(style);
  }

  function buildNotice() {
    var box = document.createElement('div');
    box.className = 'ezy-cod-notice';
    box.setAttribute('role', 'status');

    var icon = document.createElement('span');
    icon.className = 'ezy-cod-notice__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '⚠';

    var text = document.createElement('span');
    text.className = 'ezy-cod-notice__text';
    var head = document.createElement('strong');
    head.textContent = HEADING;
    text.appendChild(head);
    text.appendChild(document.createTextNode(MESSAGE));

    box.appendChild(icon);
    box.appendChild(text);
    return box;
  }

  function wireOption(optionEl) {
    if (!optionEl || optionEl.getAttribute('data-ezy-cod-notice') === '1') return;
    optionEl.setAttribute('data-ezy-cod-notice', '1');

    var notice = buildNotice();
    if (optionEl.parentNode) {
      optionEl.parentNode.insertBefore(notice, optionEl.nextSibling);
    } else {
      return;
    }

    function refresh() {
      var hiddenOption = optionEl.offsetParent === null;
      var chosen = optionEl.classList.contains(SELECTED_CLASS) && !hiddenOption;
      notice.classList.toggle('ezy-is-visible', chosen);
    }

    try {
      new MutationObserver(refresh).observe(optionEl, {
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    } catch (e) {
      /* observer unsupported — fall back to click handling only */
    }
    optionEl.addEventListener('click', function () { setTimeout(refresh, 0); });
    refresh();
  }

  function scan() {
    var found = false;
    for (var i = 0; i < COD_OPTION_IDS.length; i++) {
      var el = document.getElementById(COD_OPTION_IDS[i]);
      if (el) { found = true; wireOption(el); }
    }
    if (found) injectStyles();
  }

  var pending = false;
  function scheduleScan() {
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      pending = false;
      scan();
    }, 50);
  }

  function start() {
    scan();
    try {
      new MutationObserver(scheduleScan).observe(document.body || document.documentElement, {
        childList: true,
        subtree: true
      });
    } catch (e) {
      setInterval(scan, 1000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
